import { defineTokens } from "@chakra-ui/react";

export const radii = defineTokens.radii({
  none: {
    value: "0",
  },
  "2xs": {
    value: "0.1rem",
  },
  xs: {
    value: "0.2rem",
  },
  sm: {
    value: "0.4rem",
  },
  md: {
    value: "0.6rem",
  },
  lg: {
    value: "0.8rem",
  },
  xl: {
    value: "1.2rem",
  },
  "2xl": {
    value: "1.6rem",
  },
  "3xl": {
    value: "1.8rem",
  },
  "4xl": {
    value: "2.2rem",
  },
  full: {
    value: "9999px",
  },
});
